<template>
  <div id="aam-container">
    <div :v-wechat-title="articleInfo.classData.title" class='menu-container'></div>
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <!-- 预加载 -->
    <div v-if="articleInfo.classData.videoType === undefined"></div>
    <!-- 视频文章 -->
    <VideoArticle v-if="articleInfo.classData.videoType === true" :article-info="articleInfo"></VideoArticle>
    <!-- 普通文章 -->
    <MarkdArticle v-if="articleInfo.classData.videoType === false" :article-info="articleInfo"></MarkdArticle>
    <!-- 返回顶部 -->
    <BackTop></BackTop>
  </div>
</template>

<script>

import MarkdArticle from "@/views/article/type/MarkdArticle";
import VideoArticle from "@/views/article/type/VideoArticle";
import AxiosBase from "@/components/axiosBase";
import BackTop from "@/views/share/BackTop";
import HeaderMain from "@/views/share/HeaderMain";

import "./article.css"

export default {
  name: "Article",
  components: {
    HeaderMain,
    BackTop,
    VideoArticle,
    MarkdArticle
  },
  data() {
    return {
      articleInfo: {
        classData: {
          videoType: undefined
        },
        authorData: {}
      }
    }
  },
  beforeCreate() {
    this.$nextTick(() => {
      if (this.$route.params.id === undefined || this.$route.params.id === '') {
        this.$router.push("/404")
      } else {
        AxiosBase.axiosGet("/curriculum/class", {
          params: {
            id: this.$route.params.id
          }
        }).then(response => {
          if (response === 0) {
            this.$router.push("/404")
          } else {
            this.articleInfo = response.data
            document.title = this.articleInfo.classData.name;
          }
        })
      }
    })

  }
}
</script>

